import React, { useState } from "react";
import {
  Flex,
  Box,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  TagLabel,
  Badge,
  Input,

  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  MenuDivider,
} from "@chakra-ui/react";
import { useAppContext } from "../../contexts/AppContext";
import { EllipsisVertical } from "lucide-react";

const LibraryTable = ({ fund }) => {
  const { formatDate, tableSize, getFileIcon } = useAppContext();
  const [searchTerm, setSearchTerm] = useState("");

  

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  // Filtre les fichiers par nom ou type en fonction du terme de recherche
  const filteredFiles = fund?.library?.filter((file) => 
    file.fileName.toLowerCase().includes(searchTerm) ||
    file.type.toLowerCase().includes(searchTerm)
  );


  return (
    <>
      <Flex mb={4} justifyContent="space-between" align="center">
        <Input
          placeholder="Search files by name or type..."
          value={searchTerm}
          onChange={handleSearchChange}
          width="100%"
        />
      </Flex>

    {filteredFiles && filteredFiles.length > 0 ? (
      <TableContainer>
      <Table variant="simple" size={tableSize}>
        <Thead>
          <Tr>
            <Th>File name</Th>
            <Th>Type</Th>
            <Th>Upload date</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredFiles.map((file, index) => (
            <Tr key={index}>
              <Td fontWeight="500">
                <Flex align="center" gap={4}>
                  <Box w="20px" h="20px">{getFileIcon(file.fileName)}</Box>
                  {file.fileName}
                </Flex>
              </Td>
              <Td>
                <Tag colorScheme="brand">
                  <TagLabel>{file.type}</TagLabel>
                </Tag>
              </Td>
              <Td>
                <Badge colorScheme="transparent">{formatDate(file.createdDate)}</Badge>
              </Td>
              <Td textAlign={"right"}>
                <Menu>
                <MenuButton as={IconButton} variant={"ghost"} size={"xs"} icon={<EllipsisVertical size={12} />} />
                <MenuList>
                    <MenuItem>View</MenuItem>
                    <MenuItem>Download</MenuItem>
                    <MenuItem>Send by email</MenuItem>
                    <MenuDivider />
                    <MenuItem color={"red.500"}>Delete</MenuItem>
                  </MenuList>
                </Menu>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
    ) : (
      <Box textAlign="center" py={10} color="gray.500">
      No documents
    </Box>
    )}
      
    </>
  );
};

export default LibraryTable;
